import {Divider, makeStyles} from '@material-ui/core';
import {toKebabCase} from 'Shared/utilities/stringFormatHelpers';
import React from 'react';
import {QuoteFormElement} from './QuoteFormElement';

type GridHeaderBaseProps = {
  header: string;
};

type SectionLabelOnlyProps = {
  variant: 'label-only';
} & GridHeaderBaseProps;

type SectionLabelWithCheckboxProps = {
  variant: 'label-with-checkbox';
  isChecked: boolean;
  disabled?: boolean;
  handleChange: (value: boolean) => void;
} & GridHeaderBaseProps;

type SectionLabelProps = SectionLabelOnlyProps | SectionLabelWithCheckboxProps;

const useSectionLabelStyles = makeStyles(() => ({
  header: {
    fontSize: '0.875rem',
    color: '#2f3847',
    textTransform: 'uppercase'
  },
  divider: {
    width: '100%',
    margin: '0.25rem 0',
  },
}));

const Label = ({header}: {header: string}) => {
  const classes = useSectionLabelStyles();
  return <span className={classes.header}>{header}</span>;
};

export const SectionLabel = (props: SectionLabelProps) => {
  const classes = useSectionLabelStyles();
  return (
    <>
      {props.variant === 'label-with-checkbox' ? (
        <QuoteFormElement
          elementType="FormControl"
          controlType="checkbox"
          label={<Label header={props.header} />}
          checked={props.isChecked}
          id={toKebabCase(props.header)}
          disabled={props.disabled}
          onChange={e => props.handleChange(e.target.checked)}
        />
      ) : (
        <Label header={props.header} />
      )}
      <Divider className={classes.divider} />
    </>
  );
};
